module.exports = require("node-forge");